import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardTitle, Row, Col } from 'reactstrap';
import cowIcon from "../../assets/Images/Cow icon.png"; // Assuming you still want to use the cow icon for now
import API, { action } from '../../Api';
const Imageurl = process.env.REACT_APP_MAIN_URL + "uploads/"
const UserCard = ({ name, icon, isSelected, onSelect }) => {
  const [imgSrc, setImgSrc] = useState(icon);
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setImgSrc(icon);
    setImgError(false);
  }, [icon]);

  const handleImageError = () => {
    if (!imgError) {
      setImgError(true);
      setImgSrc(cowIcon); // Set to cow icon instead of empty string
    }
  };

  return (
    <Row
      className={`align-items-center py-2`}
      onClick={onSelect}
      style={{ cursor: 'pointer' }}
    >
      <Col xs="auto">
        <img
          src={imgSrc}
          alt="user icon"
          style={{ width: '24px', height: '24px', marginLeft: "8px" }}
          onError={handleImageError}
        />
      </Col>
      <Col>
        <CardTitle style={{ margin: 0, padding: 0, fontWeight: isSelected ? 600 : 400 }}>
          {name}
        </CardTitle>
      </Col>
    </Row>
  );
};

const CattleDashboardSideBar = ({ onTabSelect, onCattleSelect, cattleList, page, selectedCattle, preferredCattleId = null, disableAutoSelectFirst = false }) => {
    const [selectedUser, setSelectedUser] = useState(null);
    const [visibleUsers, setVisibleUsers] = useState(300); // Controls how many users are visible
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMoreData, setHasMoreData] = useState(true); // Flag to indicate if there's more data

    const handleSelect = (name, cattleData) => {
        setSelectedUser(name);
        onCattleSelect && onCattleSelect(cattleData);
        onTabSelect && onTabSelect(name);
    };

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollTop + clientHeight >= scrollHeight - 5 && !isLoading && hasMoreData) {
            setIsLoading(true); // Set loading state to true
            setTimeout(() => {
                // Increment the page number after a 5-second delay
                page(prevPage => {
                    const nextPage = prevPage + 1;
                    return nextPage;
                });
            },);
        }
    };

    useEffect(() => {
        const formattedUsers = cattleList.map(cattle => ({
            name: `Cattle No. ${cattle.cattle_id.toString().toLowerCase().replace(/\b\w/g, l => l.toUpperCase())}`,
            icon: cattle.image ? Imageurl + cattle.image : cowIcon,
            data: cattle,
        }));
        setUsers(formattedUsers);
        // Priority 1: preferredCattleId (e.g., newly created)
        if (preferredCattleId) {
            const normalize = (v) => (v === null || v === undefined ? '' : String(v).trim().toLowerCase());
            const target = normalize(preferredCattleId);
            const matchByPreferred = formattedUsers.find(u => normalize(u.data.cattle_id) === target);
            if (matchByPreferred) {
                setSelectedUser(matchByPreferred.name);
                if (onCattleSelect) onCattleSelect(matchByPreferred.data);
                if (onTabSelect) onTabSelect(matchByPreferred.name);
                return;
            }
        }
        // Priority 2: selectedCattle from parent
        if (selectedCattle && selectedCattle.cattle_id) {
            const matchingUser = formattedUsers.find(
                user => user.data.cattle_id === selectedCattle.cattle_id
            );

            if (matchingUser) {
                setSelectedUser(matchingUser.name);
            }
        }
    }, [cattleList, selectedCattle, preferredCattleId]);

    // Select the first user after users are set
    useEffect(() => {
        if (!disableAutoSelectFirst && users.length > 0 && !selectedUser && !preferredCattleId && !(selectedCattle && selectedCattle.cattle_id)) {
            const firstUser = users[0];
            setSelectedUser(firstUser.name);
            if (onCattleSelect) onCattleSelect(firstUser.data);
            if (onTabSelect) onTabSelect(firstUser.name);
        }
    }, [users, onCattleSelect, onTabSelect, selectedUser, cattleList, preferredCattleId, selectedCattle, disableAutoSelectFirst]);


    useEffect(() => {
        setIsLoading(false);
        if (cattleList.length === 0) {
            setHasMoreData(false);
        } else {
            setHasMoreData(true);
        }
    }, [cattleList]);

    return (
        <div className="container p-0">
            <Card
                style={{
                    borderRadius: '12px',
                    border: '1px solid #E3E3E3',
                    background: '#FFF',
                    width: '100%',

                }}
            >
                <CardBody
                    onScroll={handleScroll}
                    style={{
                        minHeight: '630px',
                        maxHeight: '630px',
                        overflowY: 'auto',
                        // height: '540px'
                    }}
                >
                    {users.slice(0, visibleUsers).map((user, index) => (
                        <div
                            key={index}
                            className="user-card"
                            style={{
                                color: selectedUser === user.name ? '#FDBF26' : '#656565',
                                fontSize: '12px',
                                fontWeight: 700,
                                fontFamily: 'Plus Jakarta Sans',
                                backgroundColor: selectedUser === user.name ? "rgba(254, 234, 183, 0.50)" : 'transparent',
                                borderRadius: '8px',
                            }}
                        >
                            <UserCard
                                name={user.name}
                                icon={user.icon}
                                isSelected={selectedUser === user.name}
                                onSelect={() => handleSelect(user.name, user.data)} // Pass the full cattle data
                            />
                            {index < visibleUsers - 1 && (
                                <hr
                                    style={{
                                        margin: '5px 0',
                                        border: selectedUser === user.name ? '1px solid rgba(254, 234, 183, 0.50)' : '1px solid #E3E3E3',
                                    }}
                                />
                            )}
                        </div>
                    ))}
                </CardBody>
            </Card>
        </div>
    );
};

export default CattleDashboardSideBar;